<template>
  <div
    class="search-content-box wit-cont-deep transition"
    :class="!searchTable_show?'open-content-box':'close-content-box'"
  >
    <el-form
      ref="ruleForm"
      :label-width="formdata.labelWidth"
      :inline="formdata.inline"
      class="demo-form-inline"
      :model="formdata"
    >
      <div class="data-content">

        <el-form-item
          v-for="(item, index) in formdata.formprops"
          :key="'form' + index"
          :label="item.label"
          :rules="item.required || []"
          :prop="'formprops.' + index + '.value'"
        >
          <!-- input -->
          <el-input
            v-if="item.formtype === 'input'"
            v-model.trim="item.value"
            :type="item.type == 'textarea' ? 'textarea' : 'input'"
            :clearable="item.clearable"
            :style="[nomalStyle,item.style] || ''"
            class="search-item"
            :class="item.className || ''"
            :size="item.size || 'small'"
            :maxlength="item.maxlength || ''"
            :prefix-icon="item.prefix || ''"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :suffix-icon="item.icon || ''"
            @keyup.native.enter="search"
            @change="
              (val) => {
                inputChange(val, item.change);
              }
            "
          />
          <el-input
            v-else-if="item.formtype === 'number'"
            v-model.number.trim="item.value"
            type="number"
            :clearable="item.clearable"
            :style="[nomalStyle,item.style] || ''"
            class="search-item"
            :class="item.className || ''"
            :size="item.size || 'small'"
            :maxlength="item.maxlength || ''"
            :prefix-icon="item.prefix || ''"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :suffix-icon="item.icon || ''"
            @keyup.native.enter="search"
            @change="
              (val) => {
                inputChange(val, item.change);
              }
            "
          />
          <!-- inputNumber -->
          <el-input-number
            v-else-if="item.formtype === 'inputNumber'"
            v-model.trim="item.value"
            :clearable="item.clearable"
            :controls="false"
            class="search-item"
            :style="[item.style,nomalStyle] || ''"
            :min="1"
            :max="10"
          />
          <!-- select或者远程搜索 -->
          <el-select
            v-else-if="item.formtype === 'select'"
            v-model="item.value"
            filterable
            class="search-item is-choose-style"
            :clearable="item.clearable"
            :remote="item.remote"
            :size="item.size || 'small'"
            :reserve-keyword="item.reserveKeyword"
            :remote-method="item.remoteMethod"
            :multiple="item.multiple"
            :collapse-tags="item.collapseTags"
            :style="[nomalStyle,item.style] || ''"
            :disabled="item.disabled"
            :placeholder="item.placeholder"
            @change="
              (val) => {
                selectChange(val, item.change);
              }
            "
            @visible-change="
              (val) => {
                selectVisibleChange(val, item.visibleChange, item.value);
              }
            "
          >
            <el-option
              v-for="(selitem, idx) in item.data()"
              :key="idx + 'select-s'"
              :label="selitem[item.personalOptions?item.personalOptions.label:'label']"
              :value="selitem[item.personalOptions?item.personalOptions.value:'value']"
            />
          </el-select>
          <!-- date -->
          <el-date-picker
            v-else-if="item.formtype === 'date'"
            v-model="item.value"
            :clearable="item.clearable"
            :type="item.datetype"
            class="search-item"
            :style="[item.style,nomalStyle] || ''"
            :range-separator="item.separator ? item.separator : '-'"
            :size="item.size || 'small'"
            :class="item.dateWidth === 'small' ? 'cl-small' : (item.datetype == 'daterange' ? 'cl-change' : 'cl-nomal')"
            :value-format="item.format"
            :format="item.formatInput ? item.formatInput : ''"
            :placeholder="item.placeholder"
            :start-placeholder="
              Array.isArray(item.placeholderarr) ? item.placeholderarr[0] : ''
            "
            :end-placeholder="
              Array.isArray(item.placeholderarr) ? item.placeholderarr[1] : ''
            "
            :picker-options="item.pickerOptions"
          />
          <!-- cascader级联 -->
          <el-cascader
            v-else-if="item.formtype === 'cascader'"
            :ref="item.casName?`${item.casName}CascaderRef`:'CascaderRef'"
            :key="'cascader' + index"
            v-model="item.value"
            :clearable="item.clearable"
            :placeholder="item.placeholder"
            :filterable="item.filterable"
            :options="item.data()"
            :show-all-levels="item.showAllLevels"
            :collapse-tags="item.collapseTags"
            class="search-item"
            :props="item.props || optionProps"
            :size="item.size || 'small'"
            :popper-class="item.popper? `${item.casName}`:null"
            :style="[nomalStyle, item.style] || ''"
            @change="
              (val) => {
                handleChange(val, item.change);
              }
            "
          />
          <!-- text -->
          <span
            v-else-if="item.formtype === 'text'"
            :style="item.style || ''"
            v-html="item.value"
          />
          <!-- 其他 -->
          <template v-else-if="item.formtype === 'render'">
            <expand-dom :column="item" :render="item.render" />
          </template>
          <slot :name="index" />

        </el-form-item>
      </div>
      <div class="btn-content">
        <el-form-item v-if="$slots.export">
          <slot name="export" />
        </el-form-item>
        <el-form-item v-if="!formdata.resetBottonflag" class="btn-box">
          <!-- <slot name="last" /> -->
          <!--class="reset-btn"-->
          <el-button size="small" @click="searchReset()">{{ formdata.btnResetText || "重置" }}
          </el-button>
        </el-form-item>
        <el-form-item v-if="!formdata.bottonflag" class="btn-box-search">
          <!--class="search-btn"-->
          <el-button type="primary" size="small" @click="search()">{{ formdata.btntext }}
          </el-button>
        </el-form-item>
        <el-form-item>
          <slot />
        </el-form-item>
        <div v-if="expanded || (showExpend && !hideMore)" class="expand" @click="handleExpand">
          <i class=" el-icon-arrow-up" :class="searchTable_show == true ? 'isReverse' : ''" />
          {{ words }}
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import { hideWordsItem } from '@/utils'

export default {
  components: {
    expandDom: {
      functional: true,
      props: {
        render: Function,
        column: {
          type: Object,
          default: null
        }
      },
      render: (h, ctx) => {
        const params = {}
        if (ctx.props.column) params.column = ctx.props.column
        return ctx.props.render(h, params)
      }
    }
  },
  // eslint-disable-next-line vue/require-prop-types
  props: ['formdata', 'hideMore', 'width', 'expanded'],
  data() {
    return {
      showExpend: false,
      nomalStyle: {
        // eslint-disable-next-line eqeqeq
        width: this.width ? this.width : (this.formdata.formprops.length == 2 ? '400px' : (this.formdata.formprops.length == 3 ? '263px' : '200px'))
      },
      searchTable_show: false,
      optionProps: {
        value: 'value',
        label: 'label',
        children: 'children'
      },
      arr: {},
      casName: ''
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    words() {
      if (this.searchTable_show === false) {
        return '展开'
      } else if (this.searchTable_show === true) {
        return '收起'
      }
    }
  },
  created() {
    // 如果包含日期选择器
    // eslint-disable-next-line eqeqeq
    if (this.formdata.formprops && (this.formdata.formprops.length == 4 || this.formdata.formprops.length == 3)) {
      const obj = this.formdata.formprops.filter(item => { return item.formtype === 'date' || item.formtype === 'select-date' })
      if (obj.length) this.showExpend = true
    } else if (this.formdata.formprops && this.formdata.formprops.length > 4) {
      this.showExpend = true
    }
  },
  methods: {
    handleExpand() {
      this.searchTable_show = !this.searchTable_show
      this.$emit('searchTableShowChange', this.searchTable_show)
      this.$emit('handleExpand', this.searchTable_show)
    },
    hideWords(val) {
      return hideWordsItem(val, 15)
    },
    search() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.formdata.formprops.map((item) => {
            if (!item.key) {
              return
            }
            if (Array.isArray(item.key)) {
              if (item.value === null) {
                item.value = []
              }
              item.key.map((arr, index) => {
                this.arr[item.key[index]] = item.value[index]
              })
            } else {
              if (item.formtype === 'cascader' && !item.level) {
                item = JSON.parse(JSON.stringify(item))
                // console.log('单个')
                this.arr[item.key] = item.value && item.value.length
                  ? [
                    item.value.length,
                    item.value.splice(item.value.length - 1).join()
                  ]
                  : item.value // 后期可能要传出层级按钮
              } else if (item.formtype === 'cascader' && item.level) {
                item = JSON.parse(JSON.stringify(item))
                this.arr[item.key] = item.value
              } else {
                this.arr[item.key] = item.value
              }
            }
          })
          this.$emit('searchFn', this.arr)
        } else {
          this.Global.formErrorScroll()
          this.arr = {}
          return false
        }
      })
      return this.arr
    },
    // 重置
    searchReset() {
      this.$emit('searchReset')
    },
    filterMethod(val, filter) {
      if (filter) {
        console.log(val, filter, 'filter变化')
        return this.$emit('filterMethod', val)
      }
    },
    selectChange(val, change, item) {
      if (change) {
        console.log(val, change, 'change变化')
        return this.$emit('selectChange', val, item)
      }
    },
    selectVisibleChange(val, change, item) {
      if (change && !val) {
        return this.$emit('selectVisibleChange', item)
      }
    },
    inputChange(val, change) {
      if (change) {
        return this.$emit('inputChange', val)
      }
    },
    handleChange(val, change) {
      console.log(val, change)
      if (change) {
        console.log(val, 'val')
        return this.$emit('cascaderChange', val)
      }
    }

  }
}
</script>
<style lang='scss' scoped>
/deep/ .el-cascader__search-input {
  min-width: 0!important;
}
/deep/.el-cascader__tags {
  align-items: center;
}
/deep/ .el-cascader .el-input--small .el-input__inner {
  height: 32px!important;
}
@import "@/styles/base";
.transition{
  transition: height 0.1s ease;
}
.search-content-box {
  /deep/ .el-form-item__content {
    .el-date-editor .el-range-separator {
      padding: 0px;
    }
  }

  padding: 20px 20px 8px 20px;
  background: #fff;
  .search-item {
    min-width: 195px;
  }
  // ui规范修改
  /deep/ .el-form-item {
    // margin-bottom: 20px;
    margin-bottom: 12px;
  }
  .cl-change {
    width: 310px !important;
  }

  .cl-nomal {
    width: 400px !important;
  }
}

/deep/ .el-form-item__content {
  line-height: 32px;
}

// 查询按钮
.search-btn {
  display: inline-block;
  width: 80px;
  height: 36px;
  color: #fff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
}
// ui规范修改
.open-content-box {
  height: 72px !important;
  overflow: hidden;
  border-radius: 4px;
  /deep/ .el-form-item {
    margin-bottom: 20px;
  }
}
// ui规范修改
.close-content-box {
  // height: auto !important;
  // /deep/ .el-form-item {
  //   margin-bottom: 12px;
  // }
  height: 120px  !important;
}

// 重置按钮
.reset-btn {
  display: inline-block;
  width: 80px;
  height: 36px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
}

.expand {
  white-space: nowrap;
  margin-left: 6px;
  margin-right: 0px;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.7);
  line-height: 22px;
 cursor: pointer;
  i {
    color: rgba(51, 51, 51, 0.7);
    font-size: 14px;
    transition: transform 0.3s;
    transform: rotateZ(180deg);

    text-align: center;
    line-height: 32px;
  }

  .isReverse {
    transform: rotateZ(0deg);
  }
}

// 筛选框间隔
/deep/ .el-form--inline .el-form-item:not(:last-child) {
  margin-right: 10px;
}
/deep/ .el-form-item {
  .el-input {
      input[type="number"] {
        padding-right: 0px;
        -moz-appearance: textfield;
        -webkit-appearance: textfield;
        // 解决el-input设置类型为number时，中文输入法光标上移问题
        line-height: 1px !important;
      }
      input[type="number"]::-webkit-inner-spin-button, input[type="number"]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
    }
}
.btn-box {
  margin-right: 10px !important;
}
.demo-form-inline {
  display: flex;
  justify-content: space-between;
}
.data-content {
  display: flex;
  margin-right: 20px;
  min-width: 820px;
  flex-wrap: wrap;
}
.btn-content {
  display: flex;
  flex-shrink: 1;
  .el-form-item:last-child {
    margin-right: 0;
  }
}
.btn-box-search {
  margin-right: 0px !important;
}
.el-button {
  min-width: 72px;
}
</style>
